import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { types } from "integrations/integrationsMetadata";

import styles from "./styles.module.css";

const Logo = ({ type, className }) => (
  <div className={classNames(styles.logo, styles[`logo${type}`], className)}/>
);

Logo.propTypes = {
  type: PropTypes.oneOf(types).isRequired,
  className: PropTypes.string
};

export default Logo;
